import React from 'react';
import { Box, Paper, Typography, Button, IconButton } from '@mui/material';
import { Phone, Close } from '@mui/icons-material';

const ShareModal = ({ open, onClose, ownerName, mobileNo }) => {
  if (!open) return null;

  // Get first letter for avatar
  const initial = ownerName ? ownerName.charAt(0).toUpperCase() : 'O';

  return (
    <Box sx={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 9999,
      display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2
    }}>
      <Paper sx={{ padding: '24px 20px', width: '100%', maxWidth: 340, textAlign: 'center', borderRadius: '16px', position: 'relative', boxShadow: '0px 4px 20px rgba(0,0,0,0.15)' }}>
        
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, color: '#999' }}>
          <Close />
        </IconButton>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box sx={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#FFF0E5', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Phone sx={{ color: '#8B4513', fontSize: 28 }} />
          </Box>
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
          Your Details Have Been Shared
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
          Your contact details have been sent to the owner. The owner will contact you shortly.
        </Typography>

        {/* Owner Info Box */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, bgcolor: '#FFF8F3', p: 1.5, borderRadius: '8px', mb: 1.5, textAlign: 'left' }}>
          <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#8B4513', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 18 }}>
            {initial}
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#333' }} noWrap>
              {ownerName || 'Property Owner'}
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#888' }}>Owner</Typography>
          </Box>
        </Box>

        {/* Phone Number Box */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, bgcolor: '#FFF8F3', p: 1.5, borderRadius: '8px', mb: 2 }}>
          <Phone sx={{ color: '#8B4513', fontSize: 20 }} />
          <Typography sx={{ fontWeight: 700, color: '#333' }}>{mobileNo || '+91 XXXXX XXXXX'}</Typography>
        </Box>

        <Button 
          fullWidth variant="contained" onClick={onClose}
          sx={{ backgroundColor: '#8B4513', color: '#fff', borderRadius: '8px', textTransform: 'none', fontSize: '16px', fontWeight: 600, py: 1, '&:hover': { backgroundColor: '#703610' } }}
        >
          OK
        </Button>
      </Paper>
    </Box>
  );
};
export default ShareModal;